/**
 * Runtime configuration for the gateway (API) and realtime (WS) endpoints.
 *
 * Host-aware: when the app is served from one of our known production apexes
 * (duck-duck-space.com / duck-duck-space.ru), the API + realtime hosts are derived from the
 * CURRENT hostname (api.<apex> / rt.<apex>). This lets a SINGLE build serve every domain — a
 * .ru visitor talks to api/rt.…ru, a .com visitor to api/rt.…com — so both live on one stack.
 * For .com the derived URLs are byte-identical to the previously-baked values, so behaviour is
 * unchanged. Anywhere else (localhost dev, previews) we fall back to the Vite build-time env.
 */
function deriveProdHosts(): { gatewayUrl: string; realtimeUrl: string } | null {
  if (typeof window === 'undefined') return null;
  const apex = /^(?:www\.)?(duck-duck-space\.(?:com|ru))$/i
    .exec(window.location.hostname)?.[1]
    ?.toLowerCase();
  if (!apex) return null;
  return { gatewayUrl: `https://api.${apex}`, realtimeUrl: `wss://rt.${apex}` };
}

const derived = deriveProdHosts();

export const config = {
  gatewayUrl: derived?.gatewayUrl ?? import.meta.env.VITE_GATEWAY_URL ?? 'http://localhost:4000',
  realtimeUrl: derived?.realtimeUrl ?? import.meta.env.VITE_REALTIME_URL ?? 'ws://localhost:2567',
} as const;

export const API_BASE = `${config.gatewayUrl}/api`;
